import { Button, Icon } from '@britishcouncil/react-admin';
import styled from '@emotion/styled';
import { SpeakingSessionDto } from 'api/planning';
import { SessionStatusBadge, DayOfTheWeekBadge } from 'components';
import { ROUTING_PATHS } from 'const';
import { generatePath, useNavigate } from 'react-router';
import { Column } from 'react-table';

const { speakingSessionDetails } = ROUTING_PATHS;

export const columns: Column<SpeakingSessionDto>[] = [
  {
    Header: 'Date',
    accessor: 'date',
    Cell: (x) => (
      <S.SpacedContainer>
        <DayOfTheWeekBadge date={x.value} />
        {x.value}
      </S.SpacedContainer>
    ),
    width: '140px',
  },
  {
    Header: 'Venue',
    accessor: 'venue',
    width: 'auto',
  },
  {
    Header: 'Registrations',
    accessor: 'numberOfRegistrations',
    width: 'auto',
  },
  {
    Header: 'Planned slots',
    accessor: 'numberOfPlannedSlots',
    width: 'auto',
  },
  {
    Header: 'Status',
    accessor: 'status',
    Cell: ({ row }) => (
      <SessionStatusBadge
        status={row.original.status}
        hasLinkedSession={row.original.hasLinkedLrwSessions}
      />
    ),
    width: '120px',
    disableSortBy: true,
  },
  {
    Header: '',
    id: 'actions',
    accessor: 'id',
    Cell: ({ value }) => {
      const navigate = useNavigate();
      return (
        <S.Button
          onClick={() =>
            navigate(generatePath(speakingSessionDetails.absolutePath, { sessionId: value }))
          }
          data-testid="view-session"
        >
          <Icon name="angle right" size="large" color="blue" />
        </S.Button>
      );
    },
    disableSortBy: true,
    width: '0',
  },
];

const S = {
  SpacedContainer: styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
  `,
  Button: styled(Button)`
    &.ui.button {
      background-color: transparent;
      padding: 2px 4px;
      & > i.icon {
        margin: 0 !important;
      }
    }
  `,
};
